import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedArticles from './components/FeaturedArticles';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '2048核基地 - 首页',
    description: '2048核基地是专为2048游戏深度玩家打造的策略攻略与挑战平台，提供最强合并技巧、核心玩法解析、高分路线图及进阶秘籍。',
    url: 'https://pmt-pbt.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '2048核基地',
      url: 'https://pmt-pbt.cn/',
    },
  };

  return (
    <>
      <SEOHead
        title="终极策略挑战中心"
        description="2048核基地是专为2048游戏深度玩家打造的策略攻略与挑战平台，提供最强合并技巧、核心玩法解析、高分路线图及进阶秘籍，帮助你突破2048极限关卡，成为顶尖玩家。"
        keywords="2048核基地,2048攻略,2048高分技巧,2048合并策略,2048进阶玩法"
        canonicalUrl="https://pmt-pbt.cn/"
        ogType="website"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <FeaturedArticles />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}